import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PersonForUser } from '../../../app-user-management/model/user-access-management.model';
import { Subject, takeUntil } from 'rxjs';
import { IpexFileService } from '../../services/ipex-file.service';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';

@Component({
    selector: 'app-pcx-avatar',
    templateUrl: './pcx-avatar.component.html',
    styleUrls: ['./pcx-avatar.component.scss'],
    standalone: false
})
export class PcxAvatarComponent implements OnInit, OnDestroy {
    @Input() person: PersonForUser;
    @Input() round = true;
    @Input() size = 24;
    @Input() bgColor = '#DADADA';
    @Input() fgColor = '#FFFFFF'; // $dark-80
    @Input() addBorderColorForImage = true;
    @Input() borderColor = '#00A780'; // $primary-500
    @Input() showEmail = false;
    @Input() matTooltip: string = '';
    @Input() matTooltipPosition = 'above';
    @Input() matTooltipClass = 'tooltip';
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private readonly ipexFileService: IpexFileService) {}

    ngOnInit(): void {
        if (!this.person?.ProfileImageId) {
            return;
        }

        this.ipexFileService
            .getFileUrlById(this.person.ProfileImageId, null, SCConfig.ImageSize.THUMBNAIL)
            .pipe(takeUntil(this.destroy$))
            .subscribe(res => {
                if (res) {
                    this.person.ProfileImage = res;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
